/* eslint-disable */
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

// import use translation ------------------------------
import { useTranslation } from "react-i18next";

import {
  getUserBrowser,
  getPublicIP,
  getTimeStamp,
} from "helper/AuthHelper/AuthHelper";

import { joinEventHandler } from "helper/EventHelper/EventHelper";
import { ecosystemSlug } from "Config/Config";

const LoginModal = () => {
  const eventId = localStorage.getItem("eventId");

  const { t } = useTranslation(); // translation marker

  const { setcreateAccountMessage, setuserEmailforOtp } =
    useContext(GlobalProvider);

  /*----- UseState to send username and password for Login ----*/
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEmailWarning, setOtpEmailWarning] = useState(false);
  const [notValidOtpEmail, setNotValidOtpEmail] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [emailWarning, setEmailWarning] = useState(false);
  const [notValidEMail, setNotValidEMail] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [passwordWarning, setPasswordWarning] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [agreeWarning, setAgreeWarning] = useState(false);
  const [otpSending, setotpSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);

  // function for change text type
  const toggleText = () => {
    setShowPassword(!showPassword);
  };

  //otp function
  const otpHandler = async () => {
    if (otpEmail == "") {
      setOtpEmailWarning(true);
    } else {
      setOtpEmailWarning(false);

      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (otpEmail.match(mailformat)) {
        setNotValidOtpEmail(false);
        try {
          setotpSending(true);
          let userData = {
            email: otpEmail,
          };
          let requestURL =
            url.API_BASE_URL +
            url.API_GET_OTP +
            `?ecosystemslug=${ecosystemSlug}`;

          const response = await postData(requestURL, userData);

          console.log(response);

          setotpSending(false);

          if (response.status) {
            setcreateAccountMessage("");
            setuserEmailforOtp(otpEmail);

            //hide login modal
            let loginModal = document.querySelector("#login_modal");
            let modal = bootstrap.Modal.getInstance(loginModal);
            modal.hide();

            //show otpconfirm modal
            let myModal = new bootstrap.Modal(
              document.getElementById("otp_confirm_login_mdl")
            );
            myModal.show();
          } else {
            setuserEmailforOtp("");
            setcreateAccountMessage(
              "Email does not exist.Please create a new account."
            );

            //hide login modal
            let loginModal = document.querySelector("#login_modal");
            let modal = bootstrap.Modal.getInstance(loginModal);
            modal.hide();

            //show register modal
            let myModal = new bootstrap.Modal(
              document.getElementById("register_mdl")
            );
            myModal.show();
          }
          setUserEmail("");
        } catch (error) {
          console.log(error.message);
        }
      } else {
        setNotValidEMail(true);
      }
    }
  };

  //login function
  const LoginHandler = async (e) => {
    e.preventDefault();
    switch (true) {
      case userEmail == "" || userPassword == "":
        userEmail == "" ? setEmailWarning(true) : setEmailWarning(false);
        userPassword == ""
          ? setPasswordWarning(true)
          : setPasswordWarning(false);
        // isAgree==false?setAgreeWarning(true):setAgreeWarning(false)
        break;
      default:
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (userEmail.match(mailformat)) {
          setNotValidEMail(false);
          setIsLoading(true);

          try {
            const detectedBrowser = getUserBrowser();
            const userPublicIp = await getPublicIP();
            const { loginDate, loginTime, loginTimeStamp } = getTimeStamp();

            let userData = {
              email: userEmail,
              password: userPassword,
              logindate: loginDate,
              logintime: loginTime,
              logintimestamp: loginTimeStamp,
              browser: detectedBrowser,
              userip: userPublicIp,
            };
            console.log(userData);

            let requestURL =
              url.API_BASE_URL +
              url.API_LOGIN +
              `?ecosystemslug=${ecosystemSlug}`;

            console.log("request url -->", requestURL);

            const response = await postData(requestURL, userData);

            console.log("response -->", response);

            if (response.status) {
              setLoginFailed(false);
              // assigning the loggedin user's id,token,all data to the browser's local storage.
              localStorage.setItem("token", response.token);
              localStorage.setItem("userInfo", JSON.stringify(response.data));
              localStorage.setItem("userID", JSON.stringify(response.data._id));
              localStorage.setItem("ecosystem", response.ecosystemid);
              localStorage.setItem("ecosystemlogo", response.ecosystemlogo);

              //membership proecess
              const eventDetailsUrl =
                url.API_BASE_URL +
                url.API_GUEST_EVENT_DETAILS_BY_ID +
                `/${eventId}`;

              const eventResponse = await getData(eventDetailsUrl);

              if (eventResponse.status) {
                if (
                  !eventResponse?.data?.eventmemberids.includes(
                    response.data._id
                  )
                ) {
                  await joinEventHandler(
                    eventResponse?.data?._id,
                    userEmail,
                    eventResponse?.data?.secret,
                    response.token
                  );
                }
              }

              resetLoginData();
              window.location.reload();
            } else {
              setLoginFailed(true);
            }
            setIsLoading(false);
          } catch (error) {
            console.error(error.message);
          }
        } else {
          setNotValidEMail(true);
        }
    }
  };

  // function for reset the useState containing the email and password text fields
  const resetLoginData = () => {
    setOtpEmail("");
    setOtpEmailWarning(false);
    setNotValidOtpEmail(false);
    setUserEmail("");
    setUserPassword("");
    setEmailWarning(false);
    setNotValidEMail(false);
    setPasswordWarning(false);
    setLoginFailed(false);
    setcreateAccountMessage("");
    setuserEmailforOtp("");
  };

  return (
    <div className="registration_modal">
      <div
        className="modal fade show"
        data-bs-backdrop="static"
        id="login_modal"
      >
        <div className="modal-dialog small_modal">
          <div className="modal-content">
            {/* ----- modal title start ----- */}
            <div className="modal-header  justify-content-between">
              <div className="signin_hdng text-left">
                <h3 className="mb-2">Sign IN</h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            {/* ----- modal title end ----- */}

            <div className="modal-body">
              <div className="login_body">
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* ------ tab menu start ----- */}
                  <div className="login_tabs">
                    <ul className="nav nav-tabs list_stye_none">
                      <li className="nav-item">
                        <Link
                          className="nav-link active show"
                          data-bs-toggle="tab"
                          to="#otp"
                          onClick={resetLoginData}
                        >
                          OTP
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          data-bs-toggle="tab"
                          to="#password"
                          onClick={resetLoginData}
                        >
                          Password
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* ------ tab menu end ----- */}

                  {/* ------ tab section start ----- */}
                  <div className="tab-content">
                    {/* ----- otp tab start ----- */}
                    <div className="tab-pane fade show active" id="otp">
                      <div className="otp_fill_outer">
                        <div className="form-group">
                          <div className="input_fill">
                            <label>{t("Email")}</label>
                            <input
                              type="email"
                              value={otpEmail}
                              onChange={(e) => {
                                setOtpEmailWarning(false);
                                setNotValidOtpEmail(false);
                                setLoginFailed(false);
                                setOtpEmail(e.target.value);
                              }}
                              className="form-control"
                              placeholder={t("Enter email")}
                            />

                            {/* ------ email warning start ------ */}
                            {otpEmailWarning && (
                              <p className="text-pink mt-2">
                                <span className="material-icons-outlined me-1">
                                  info
                                </span>
                                {t("Please enter email")}
                              </p>
                            )}
                            {/* ----- valid email warning ------ */}
                            {notValidOtpEmail && (
                              <p className="error mt-1">
                                <span className="material-icons-outlined me-1">
                                  info
                                </span>
                                {t("Please enter valid email")}
                              </p>
                            )}

                            <button
                              to="#"
                              className="btn outline mt-3"
                              onClick={otpHandler}
                              disabled={otpSending ? true : false}
                              style={{
                                cursor: otpSending ? "not-allowed" : "pointer",
                              }}
                            >
                              {t("Send OTP")}
                              {otpSending && (
                                <div
                                  className="mx-2 spinner-border spinner-border-sm"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* ----- create account section start ----- */}
                      <div className="create_login_outer d-flex align-items-center justify-content-between">
                        <div className="trms_check me-2">
                          <label className="radio-check">
                            <p>{t("Do not have an account")}?</p>
                          </label>
                        </div>

                        <div className="forgot_btn">
                          <Link
                            to="#"
                            className=""
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            data-bs-target="#register_mdl"
                          >
                            {t("Create One")}
                          </Link>
                        </div>
                      </div>
                      {/* ----- create account section end ----- */}
                    </div>
                    {/* ----- otp tab end ----- */}

                    {/* ----- password tab start ----- */}
                    <div className="tab-pane fade" id="password">
                      {/* ----- email and password section start ----- */}
                      <div className="login_fillOuter">
                        <div className="input_fill">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder={t("Enter email")}
                            value={userEmail}
                            onChange={(e) => {
                              setEmailWarning(false);
                              setNotValidEMail(false);
                              setLoginFailed(false);
                              setUserEmail(e.target.value);
                            }}
                          />
                          {/* ------ email warning start ------ */}
                          {emailWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined">
                                info
                              </span>
                              {t("Please enter email")}
                            </p>
                          )}
                          {/* ----- valid email warning ------ */}
                          {notValidEMail && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined">
                                info
                              </span>
                              {t("Please enter valid email")}
                            </p>
                          )}
                          {/* ------ email warning end ------ */}
                        </div>
                        <div className="input_fill">
                          <label>Password</label>
                          <div className="eye_btnfill position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              placeholder={t("Enter Password")}
                              value={userPassword}
                              onChange={(e) => {
                                setPasswordWarning(false);
                                setLoginFailed(false);
                                setUserPassword(e.target.value);
                              }}
                            />
                            <Link
                              to="#"
                              className="copy_link"
                              onClick={toggleText}
                            >
                              <span className="material-icons-outlined">
                                {" "}
                                visibility
                              </span>
                            </Link>
                          </div>
                          {passwordWarning && (
                            <p className="text-pink mt-2">
                              <span className="material-icons-outlined">
                                info
                              </span>
                              {t("Please enter password")}
                            </p>
                          )}
                        </div>
                      </div>
                      {/* ----- email and password section end ----- */}

                      {loginFailed && (
                        <p className="error">
                          <span className="material-icons-outlined">info</span>
                          {t("Login Failed")}
                        </p>
                      )}

                      {/* ----- agree and forgot passowrd link section start ----- */}
                      <div className="forgot_applyOuter mb-4 mt-4 justify-content-end">
                        <div className="forgot_btn">
                          <Link
                            to="#"
                            className=""
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            data-bs-target="#forgot_modal"
                          >
                            Forgot Password
                          </Link>
                        </div>
                      </div>
                      {/* ----- agree and forgot passowrd link section end ----- */}

                      <div className="create_login_outer d-flex align-items-center justify-content-between">
                        {/* <div className="apply_btn">
                          <Link
                            to="#"
                            className="btn"
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            data-bs-target="#register_mdl"
                            onClick={resetLoginData}
                          >
                            Create One
                          </Link>
                        </div> */}
                        <div className="d-flex align-items-center">
                          {" "}
                          <div className="trms_check me-2">
                            <label className="radio-check">
                              <p>{t("Do not have an account")}?</p>
                            </label>
                          </div>
                          <div className="forgot_btn">
                            <Link
                              to="#"
                              className=""
                              data-bs-toggle="modal"
                              data-bs-dismiss="modal"
                              data-bs-target="#register_mdl"
                            >
                              {t("Create One")}
                            </Link>
                          </div>
                        </div>

                        <div className="apply_btn">
                          <button
                            className="btn primary-btn"
                            onClick={LoginHandler}
                            disabled={isLoading ? true : false}
                            style={{
                              cursor: isLoading ? "not-allowed" : "pointer",
                            }}
                          >
                            {t("Login")}
                            {isLoading && (
                              <div
                                className="mx-2 spinner-border spinner-border-sm"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            )}
                          </button>
                        </div>
                      </div>

                      {/* ----- create account section start ----- */}
                      {/* <div className="create_login_outer d-flex align-items-center justify-content-between">
                        <div className="trms_check me-2">
                          <label className="radio-check">
                            <p>{t("Do not have an account")}?</p>
                          </label>
                        </div>

                        <div className="forgot_btn">
                          <Link
                            to="#"
                            className=""
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            data-bs-target="#register_mdl"
                          >
                            {t("Create One")}
                          </Link>
                        </div>

                        <div className="apply_btn">
                          <Link
                            to="#"
                            className="btn"
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            data-bs-target="#register_mdl"
                            onClick={resetLoginData}
                          >
                            {t("Create One")}
                          </Link>
                        </div>
                      </div> */}
                      {/* ----- create account section end ----- */}
                    </div>
                    {/* ----- password tab end ----- */}
                  </div>
                  {/* ------ tab section end ----- */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
